// This file contains data related to this project!

export const skillData = [
  { name: "React" },
  { name: "TypeScript" },
  { name: "Node.js" },
  { name: ".NET" },
  { name: "GraphQL" },
  { name: "Azure" },
  { name: "Git" },
  { name: "REST APIs" },
  { name: "SQL" },
  { name: "Docker" },
  { name: "Apollo Federation" },
  { name: "Jest" },
  { name: "CI/CD" },
  { name: "Zodios" },
  { name: "Zod" },
];

export const navItems = [
  { label: "Home", path: "/" },
  { label: "Experience", path: "/experience" },
  { label: "Projects", path: "/projects" },
  { label: "Contact", path: "/contact" },
];
